import apiClient from './apiClient';
import { GET_CATERING_SETTINGS, UPDATE_CATERING_SETTINGS } from '../constants/UriConstants';
import { CateringSettingsInterface, UpdateCateringSettingsRequest } from '../types/CateringSettingsInterface';

export const getCateringSettings = (): Promise<CateringSettingsInterface> =>
  apiClient.get(GET_CATERING_SETTINGS).then((response) => response.data);

export const updateCateringSettings = (update: UpdateCateringSettingsRequest): Promise<CateringSettingsInterface> =>
  apiClient.put(UPDATE_CATERING_SETTINGS, update).then((response) => response.data);
